import tracking from '../../utils/tracking';

const vids = document.querySelectorAll(".custom-vid") as any as HTMLElement[];
const tabs = document.querySelectorAll(".vid-tab");
const locale = document.documentElement.getAttribute("lang") as string;

const videoContainer = document.getElementById("video-container");

let hasClicked = false;
let numOfLoops = 0;
let clickedEl: HTMLElement | null = null;
let startLoop: NodeJS.Timer;

let startTime = 0;
let interruptionTime = 0;

function slugify(title: string) {
  return title
    ? title.toLowerCase().replace(/ /g, "_")
    : document.querySelector(".vid-tab.active")?.id;
}

function switchVid(currentVid: HTMLElement) {
  numOfLoops++;
  startTime = Date.now();
  vids.forEach((vid) => {
    vid.classList.remove("playing", "paused");
    vid.classList.add("invis");
    void vid.offsetWidth;
    void vid.offsetHeight;
  });
  tabs.forEach((tab) => {
    tab.classList.remove("active");
  });
  document.getElementById("vid-tab-" + currentVid.id)?.classList.add("active");
  currentVid.classList.remove("invis");
  currentVid.classList.add("playing");

  if (!hasClicked && numOfLoops < tabs.length) {
    tracking.trackEvent(
      slugify(currentVid.getAttribute("data-title") || '') + "_start",
      {
        title: currentVid.getAttribute("data-title"),
      }
    );
  }
  let timeOut = Number(currentVid.getAttribute("data-length"));
  let nextVid = (currentVid.nextElementSibling
    ? currentVid.nextElementSibling
    : vids[0]) as HTMLElement;

  setTimeout(() => {
    if (!hasClicked) {
      switchVid(nextVid);
    }
  }, timeOut);
}

tabs.forEach((tab) => {
  tab.addEventListener("click", (e) => {
    tracking.trackEvent(
      slugify(tab.getAttribute("data-title")) + "_click",
      {
        title: tab.getAttribute("data-title"),
      }
    );
    let currentTab = e.target;
    hasClicked = true;
    clearInterval(startLoop);

    // @ts-ignore
    let nextVideoId = e.target?.id.replace("vid-tab-", "");
    let nextVid = document.getElementById(nextVideoId) as HTMLElement;

    // @ts-ignore
    if (!currentTab?.classList.contains("active")) {
      let timeOut = Number(nextVid.getAttribute("data-length"));
      switchVid(nextVid);
      clickedEl = nextVid;
      startLoop = setInterval(function () {
        if (clickedEl == nextVid) {
          nextVid.classList.remove("playing");
          switchVid(nextVid);
        } else {
          clearInterval(startLoop);
        }
      }, timeOut);
    } else if (nextVid.classList.contains("paused")) {
      let timeOut = Number(
        nextVid.getAttribute("data-length") - (interruptionTime - startTime)
      );
      nextVid.classList.remove("paused");
      currentTab.classList.remove("paused");
      setTimeout(function () {
        switchVid(nextVid);
      }, timeOut);
    } else {
      interruptionTime = Date.now();
      nextVid.classList.add("paused");
      currentTab.classList.add("paused");
      tracking.trackEvent(
        slugify(currentTab.getAttribute("data-title")) + "_pause",
        {
          title: currentTab.getAttribute("data-title"),
        }
      );
    }
  });
});

if (!document.body.classList.contains("edit")) {
  if (vids && vids.length > 0) {
    switchVid(vids[0]);
  }
}

let months = videoContainer?.querySelectorAll(".monthstamp");
let dates = videoContainer?.querySelectorAll(".datestamp");
let todayTime = new Date();
let todayMonth = todayTime.getMonth();
let todayDate = todayTime.getDate();

months?.forEach((stamp, index) => {
  let thisMonth = new Date(todayTime);
  thisMonth.setMonth(todayMonth + index);
  let labelMonth = thisMonth.toLocaleDateString(locale, {
    month: "long",
  });
  (stamp as HTMLElement).innerText = labelMonth;
});

dates?.forEach((datestamp, index) => {
  let thisDay = new Date(todayTime);
  thisDay.setDate(todayDate + index + 1);
  let labelDay = thisDay.toLocaleDateString(locale, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
  (datestamp as HTMLElement).innerText = labelDay;
});
